/**
 * レンガテクスチャを生成するクラス
 */
export class BrickTexture {
    /**
     * レンガテクスチャを生成する
     * @param {Phaser.Scene} scene - テクスチャを生成するシーン
     * @param {Object} options - テクスチャ生成オプション
     * @param {string} options.textureName - 生成するテクスチャの名前（デフォルト: 'brick'）
     * @param {number} options.brickWidth - レンガの幅（デフォルト: 64）
     * @param {number} options.brickHeight - レンガの高さ（デフォルト: 32）
     * @returns {boolean} テクスチャ生成の成否
     */
    static create(scene, options = {}) {
        const textureName = options.textureName || 'brick';
        const brickWidth = options.brickWidth || 64;
        const brickHeight = options.brickHeight || 32;
        
        try {
            // 既にテクスチャが存在する場合は作成しない
            if (scene.textures.exists(textureName)) {
                console.log(`BrickTexture: ${textureName}テクスチャは既に存在します`);
                return true;
            }
            
            const graphics = scene.add.graphics();
            
            // 複数のレンガを含むパターンを作成（2x2のレンガパターン）
            const patternWidth = brickWidth * 2;
            const patternHeight = brickHeight * 2;
            
            // 1行目のレンガ
            // 1つ目のレンガ
            graphics.fillStyle(0xb35a1f, 1); // 茶色
            graphics.fillRect(0, 0, brickWidth, brickHeight - 4);
            graphics.fillStyle(0x7a3b1d, 1); // 暗い茶色
            graphics.fillRect(0, brickHeight - 4, brickWidth, 4);
            graphics.fillRect(brickWidth / 2 - 2, 0, 4, brickHeight - 4);
            
            // 2つ目のレンガ
            graphics.fillStyle(0xc46a2f, 1); // 少し明るい茶色
            graphics.fillRect(brickWidth, 0, brickWidth, brickHeight - 4);
            graphics.fillStyle(0x7a3b1d, 1); // 暗い茶色
            graphics.fillRect(brickWidth, brickHeight - 4, brickWidth, 4);
            graphics.fillRect(brickWidth + brickWidth / 2 - 2, 0, 4, brickHeight - 4);
            
            // 2行目のレンガ（ずらして配置）
            // 1つ目のレンガ（半分だけ表示）
            graphics.fillStyle(0xb35a1f, 1); // 茶色
            graphics.fillRect(0, brickHeight, brickWidth / 2, brickHeight - 4);
            graphics.fillStyle(0x7a3b1d, 1); // 暗い茶色
            graphics.fillRect(0, brickHeight * 2 - 4, brickWidth / 2, 4);
            
            // 2つ目のレンガ（中央）
            graphics.fillStyle(0xc46a2f, 1); // 少し明るい茶色
            graphics.fillRect(brickWidth / 2, brickHeight, brickWidth, brickHeight - 4);
            graphics.fillStyle(0x7a3b1d, 1); // 暗い茶色
            graphics.fillRect(brickWidth / 2, brickHeight * 2 - 4, brickWidth, 4);
            graphics.fillRect(brickWidth / 2 + brickWidth / 2 - 2, brickHeight, 4, brickHeight - 4);
            
            // 3つ目のレンガ（半分だけ表示）
            graphics.fillStyle(0xb35a1f, 1); // 茶色
            graphics.fillRect(brickWidth * 1.5, brickHeight, brickWidth / 2, brickHeight - 4);
            graphics.fillStyle(0x7a3b1d, 1); // 暗い茶色
            graphics.fillRect(brickWidth * 1.5, brickHeight * 2 - 4, brickWidth / 2, 4);
            
            // テクスチャとして生成（より大きなパターン）
            graphics.generateTexture(textureName, patternWidth, patternHeight);
            graphics.destroy();
            
            console.log(`BrickTexture: ${textureName}テクスチャを生成しました`);
            return true;
        } catch (error) {
            console.error(`BrickTexture: ${textureName}テクスチャの生成中にエラーが発生しました`, error);
            
            // エラーが発生した場合、フォールバックとして単純な四角形のテクスチャを生成
            try {
                const fallbackGraphics = scene.add.graphics();
                fallbackGraphics.fillStyle(0xb35a1f, 1); // 茶色
                fallbackGraphics.fillRect(0, 0, 128, 64);
                fallbackGraphics.generateTexture(textureName, 128, 64);
                fallbackGraphics.destroy();
                console.log(`BrickTexture: フォールバックの${textureName}テクスチャを生成しました`);
                return true;
            } catch (fallbackError) {
                console.error(`BrickTexture: フォールバックテクスチャの生成にも失敗しました`, fallbackError);
                return false;
            }
        }
    }
}
